import { render, staticRenderFns } from "./SidebarOperator.vue?vue&type=template&id=fa3b403a&scoped=true&"
import script from "./SidebarOperator.vue?vue&type=script&lang=js&"
export * from "./SidebarOperator.vue?vue&type=script&lang=js&"
import style0 from "./SidebarOperator.vue?vue&type=style&index=0&id=fa3b403a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3b403a",
  null
  
)

export default component.exports